import _ from 'lodash';
import React from 'react';
import { memberBillableTypes } from '~/lookups';
import SingleSelectFilter from './SingleSelectFilter';

const defaultOptions = _.values(memberBillableTypes);

export default function MemberBillableTypeFilter({
  placeholder = 'Member Workspace Billability',
  name,
  value,
  onChange,
  options = defaultOptions,
}) {
  return (
    <SingleSelectFilter
      icon="filter"
      placeholder={placeholder}
      name={name}
      value={value}
      renderValue={(value) => value.name}
      options={options}
      onChange={onChange}
    />
  );
}
